var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhantom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "token-branded:phantom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.63949 16.6673C5.76616 16.6673 7.36449 14.8907 8.31783 13.4865C8.20407 13.7799 8.14313 14.091 8.13783 14.4057C8.13783 15.2256 8.62782 15.8098 9.59449 15.8098C10.922 15.8098 12.3395 14.6915 13.0745 13.4865C13.0249 13.6432 12.9988 13.8063 12.997 13.9707C12.997 14.5423 13.332 14.9032 14.0153 14.9032C16.1678 14.9032 18.3337 11.2365 18.3337 8.03148C18.3337 5.53315 17.0187 3.33398 13.7187 3.33398C7.91866 3.33398 1.66699 10.144 1.66699 14.5423C1.66699 16.2698 2.63366 16.6673 3.63949 16.6673ZM11.7212 7.75732C11.7212 7.13648 12.082 6.70148 12.6103 6.70148C13.1262 6.70148 13.487 7.13648 13.487 7.75732C13.487 8.37898 13.1262 8.82648 12.6103 8.82648C12.082 8.82648 11.7212 8.37898 11.7212 7.75732ZM14.4795 7.75732C14.4795 7.13648 14.8403 6.70148 15.3687 6.70148C15.8853 6.70148 16.2453 7.13648 16.2453 7.75732C16.2453 8.37898 15.8845 8.82648 15.3687 8.82648C14.8403 8.82648 14.4795 8.37898 14.4795 7.75732Z",
    fill: "#AB9FF2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/phantom.ac81b760b898c0637779073960831c06.svg";
export { ForwardRef as ReactComponent };